import './panel.css';

import { cn } from '@/services/utils';

const PanelBody = ({
    children,
    className,
    ...props
}: React.HTMLAttributes<HTMLDivElement>) => {
    return (
        <div
            className={cn('scoped-panel-header tw-h-[78vh]', className)}
            {...props}
        >
            {children}
        </div>
    );
};

PanelBody.displayName = 'PanelBody';

export { PanelBody };
